import React, { useState, useEffect, useRef } from 'react';

const CategoryCombobox = ({ categories = [], value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value || '');
  const [filteredCategories, setFilteredCategories] = useState([]);
  const wrapperRef = useRef(null);

  // Filter categories based on input
  useEffect(() => {
    if (inputValue) {
      const filtered = categories.filter(category => 
        category.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredCategories(filtered);
    } else {
      setFilteredCategories(categories);
    }
  }, [inputValue, categories]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
  setInputValue(value || '');
}, [value]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    onChange(e.target.value);
    setIsOpen(true);
  };

  const handleSelectCategory = (category) => {
    setInputValue(category);
    onChange(category);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={wrapperRef}>
      <div className="flex">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setIsOpen(true)}
          className="border rounded p-2 w-full"
          placeholder="Select or type a category"
        />
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="border border-l-0 rounded-r px-2 bg-gray-100"
        >
          {isOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          )}
        </button>
      </div>
      
      {isOpen && (
        <ul className="absolute z-10 w-full mt-1 max-h-60 overflow-auto bg-white border rounded shadow-lg">
          {filteredCategories.length > 0 ? (
            filteredCategories.map((category, index) => (
              <li
                key={index}
                onClick={() => handleSelectCategory(category)}
                className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
              >
                {category}
              </li>
            ))
          ) : (
            <li className="px-4 py-2 text-gray-500">
              No matching categories. Type to create a new one.
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default CategoryCombobox;